module.exports = __webpack_public_path__ + "assets/553a23b881c4fadb15a9626ec2dc1abf.png";